export default {
  title: 'Menu edit history',
  subtitle: 'See who changed prices, availability and visibility for {{company}} — and when.',
  filters: {
    type: {
      label: 'Type',
    },
    item: {
      placeholder: 'All items',
    },
    event: {
      label: 'Event',
    },
  },
  columns: {
    when: 'When',
    who: 'Changed by',
    type: 'Type',
    item: 'Item',
    event: 'Event',
    changes: 'Changes',
  },
  types: {
    product: 'Product',
    modifier: 'Modifier',
  },
  events: {
    created: 'Created',
    updated: 'Updated',
    deleted: 'Deleted',
  },
  fields: {
    name: 'Name',
    description: 'Description',
    price: 'Price',
    is_available: 'Availability',
    is_visible: 'Visibility',
    is_available_for_pickup: 'Pickup availability',
    is_available_for_delivery: 'Delivery availability',
  },
  booleans: {
    on: 'Available',
    off: 'Unavailable',
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
  },
  causers: {
    orders_terminal: 'Orders terminal',
  },
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Failed to load the menu edit history',
  },
};
